module.exports = __webpack_public_path__ + "img/69.67d955fd.jpg";